<ng-template #ModalExclui>
  <div class="modal-content">
    <div class="modal-header">
      <a>Excluir Usuario</a>
      <mat-icon class="btn-fechar" (click)="fecharModal()">close</mat-icon>
    </div>

    <div class="modal-body text-center p-5">
      <p class="p__div">Deseja excluir o usuário "{{userToDelete.nome}}" ?</p>
      <div class="div-button mt-5">
        <button (click)="fecharModal()" class="button-secondary">
          Cancelar
        </button>
        <button (click)="doDeletar()" class="button-primary">
          Excluir
        </button>
      </div>
    </div>
  </div>
</ng-template>